import body from './images/body.png';
import markings from './images/markings.png';
import background from './images/background.png';
import head from './images/head.png';
import texture from './images/texture.png';
import legs from './images/legs.png';
import { TraitType } from 'components/TraitCard/BaseTraitCard';
import { AttributeRaw, CollectionEntities } from 'components/Collection/model';

function replaceUnderscoresAndAddSpaces(traitType: string) {
  return traitType
    .replace(/_/g, ' ')
    .split(/([A-Z][a-z]+)|([a-z]+)/)
    .join(' ');
}

export type Attribute = {
  name: string;
  description: string;
  type: TraitType;
  src?: string;
};

const traitImageMappings = {
  bodyType: body,
  headType: head,
  legType: legs,
  textureType: texture,
  markingsType: markings,
  // different endpoints have it named differently
  body_type: body,
  head_type: head,
  leg_type: legs,
  texture_type: texture,
  markings_type: markings,
  background,
};

export function extractHexFromColorTrait(traitValue: string): string | undefined {
  return traitValue.match(/#[0-9a-fA-F]+/)?.[0];
}

export const traitAttributesTransformer = {
  toTraitAttribute(raw: AttributeRaw, collection?: string): Attribute {
    switch (collection) {
      case CollectionEntities.Eggs:
        return {
          name: raw.traitType,
          description: raw.value,
          type: TraitType.Shape,
        };
      case CollectionEntities.Duskbreakers:
        return {
          name: raw.traitType,
          description: !!raw.value === false ? 'No' : raw.value,
          type: TraitType.Shape,
        };
      case CollectionEntities.Gribbles:
        const shapeSrc = traitImageMappings[raw.traitType as keyof typeof traitImageMappings];
        const colorSrc =
          !shapeSrc &&
          (extractHexFromColorTrait(raw.value) ??
            (raw.value.toLowerCase().includes('offset') ? 'offset' : 'gradient'));

        return {
          name: replaceUnderscoresAndAddSpaces(raw.traitType),
          description: raw.value,
          type: shapeSrc ? TraitType.Shape : TraitType.Color,
          src: shapeSrc ?? colorSrc,
        };
      default:
        throw Error(`${collection} is not a valid collection type`);
    }
  },
};
